<template>
  <div class="Footer Aligner">
    <div class="container color-white">
      Todos os direitos reservados
      <span v-if="isDevelopment" >-<span class="dev-indicator">ENV: DEV | BUILD ID: {{ buildGuid }}</span></span>
    </div>
  </div>
</template>

<script>
import { isDevelopment } from '../../utils/dev-env';

export default {
  data() {
    return {
      isDevelopment,
      buildGuid: process.env.VUE_APP_BUILD_GUID || ''
    };
  }
};
</script>

<style scoped>
.dev-indicator {
  color: #4cff4c;
  font-weight: bold;
  margin-left: 8px;
}
</style>
